module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('h2', {
    staticClass: "grey--text text--darken-2"
  }, [_vm._v("Profil")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xs": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "layout",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-card-media', {
    attrs: {
      "src": _vm.basePath + 'storage/img/person_grey.png',
      "height": "125px",
      "contain": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.title)), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.authUser.forename) + " " + _vm._s(_vm.authUser.name))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.authUser.email))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "layout",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n\n                                Rollen:\n                            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('p', _vm._l((_vm.userRoles), function(role, i) {
    return _c('span', {
      key: i
    }, [_vm._v("\n                                        " + _vm._s(role.name) + " "), _c('br'), _vm._v("\n                                        ("), _c('i', [_vm._v(_vm._s(role.description))]), _vm._v(")\n                                    ")])
  }))])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "layout",
    attrs: {
      "xs4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n                                 Sprachen:\n                            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('p', [_vm._v("                                            \n                                    Backend Sprache: " + _vm._s(_vm.belanguage) + "\n                                ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x10": "",
      "offset-xs1": ""
    }
  }, [_c('p', [_vm._v("                                            \n                                    Frontend Sprache: " + _vm._s(_vm.felanguage) + "\n                                ")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-flex', {
    attrs: {
      "xs4": "",
      "offset-xs6": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/dashboard",
      "exact": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    staticClass: "red--text",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("close")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f5543e7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/profile.vue
// module id = 332
// module chunks = 0